import { render } from "./iaNumbers.vue?vue&type=template&id=5d6183a8&scoped=true"
import script from "./iaNumbers.vue?vue&type=script&lang=js"
export * from "./iaNumbers.vue?vue&type=script&lang=js"

import "./iaNumbers.vue?vue&type=style&index=0&id=5d6183a8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6183a8"]])

export default __exports__